import React from "react";
import { Box, LinearProgress, linearProgressClasses, } from "@mui/material";
import { styled, keyframes } from "@mui/material/styles";
import { useSelector } from "react-redux";
// @ts-ignore
import { FEATURE_CUSTOM_REDUX } from "../../constant";
import { Tooltip, Typography } from "@material-ui/core";
// @ts-ignore
import { getBaseConfig, isSocialMobileApp } from "../../Utils";
// @ts-ignore
import { ct } from "../../constant-Utils";
const stripes = keyframes `
  from {
    background-position: 0 0;
  }
  to {
    background-position: 100% 100%;
  }
`;
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 15,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.mode === "light" ? "#31abb1" : "#308fe8",
        // backgroundImage: `repeating-linear-gradient(
        //         45deg,
        //         transparent,
        //         transparent 0.6rem,
        //         #1976d266 0.6rem,
        //         #1976d266 1.2rem
        //       )`,
        // animation: `${stripes} 8s linear infinite`,
        backgroundSize: `200% 200%`,
    },
}));
export const LinearProgressBar = (props) => {
    const { userLoginData } = useSelector((state) => state[FEATURE_CUSTOM_REDUX]);
    const sendToProfile = () => {
        if (window.parent) {
            window.parent.location.href = getBaseConfig("socialBaseUrl") + "/users/profile";
        }
        else {
            window.location.href = getBaseConfig("socialBaseUrl") + "/users/profile";
        }
    };
    const isProfileCompleted = userLoginData?.profilePercentage == 100;
    const isSocialApp = isSocialMobileApp() ? true : false;
    return (React.createElement(Box, { sx: { display: "flex", alignItems: "center" } },
        React.createElement(Box, { sx: { width: "100%", mr: 1 } },
            React.createElement(BorderLinearProgress, { value: userLoginData?.profilePercentage || 0, variant: "determinate" })),
        React.createElement(Box, { sx: { position: "absolute", left: "50%" } },
            React.createElement(Typography, { className: "progress-percentage", variant: "body2" }, `${Math.round(userLoginData?.profilePercentage || 0)}%`)),
        !isSocialApp && (React.createElement(Box, { sx: { minWidth: 20, textAlignLast: "center" } },
            React.createElement(React.Fragment, null, !isProfileCompleted ? (React.createElement(Typography, { onClick: sendToProfile, variant: "body2" },
                React.createElement(Tooltip, { title: ct("Translate.tooltipContent.completeProfile") },
                    React.createElement("i", { className: "fa fa-pencil theme-font-color", style: { fontSize: "14px" }, "aria-hidden": "true" })))) : (React.createElement(Typography, { variant: "body2" },
                React.createElement(Tooltip, { title: ct("Translate.tooltipContent.profileCompleted") },
                    React.createElement("i", { style: { fontSize: "14px" }, className: "fa fa-check-circle theme-font-color", "aria-hidden": "true" })))))))));
};
